import { ErrorDto } from '@/types/error.type';

class CustomError extends Error {
  timestamp;
  constructor(public error: ErrorDto) {
    super(error.message);
    this.stack = (<any>new Error()).stack;
    this.name = error.name;
    this.message = error.message;
    this.timestamp = error.timestamp;
  }
}

export default CustomError;
